import { useDidUpdate } from "app/custom-hooks/useDidUpdate";

const useAbortableEffect = (effect: (signal: AbortSignal) => void, dependencies: unknown[]) => {
    useDidUpdate(() => {
        const controller = new AbortController();
        effect(controller.signal);

        return () => {
            controller.abort();
        };
    }, dependencies);
};

export default useAbortableEffect;
